import classNames from 'classnames';
import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { language } from '../utils/Env';
import { ModalContext } from './context';

const PORTAL_ROOT_ID = 'modal-root';

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

ModalContainer.propTypes = {
  modalInfos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      Modal: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
};

function ModalContainer({ modalInfos }) {
  const portalRootElemRef = useRef(document.getElementById(PORTAL_ROOT_ID));

  useEffect(() => {
    if (portalRootElemRef.current) return;

    const elem = document.createElement('div');
    elem.id = PORTAL_ROOT_ID;
    document.body.appendChild(elem);
    portalRootElemRef.current = document.getElementById(PORTAL_ROOT_ID);
  }, []);

  return (
    modalInfos?.length > 0 &&
    createPortal(
      <div className={classNames('ly_wrap dimmed', language)}>
        {modalInfos.map(({ id, Modal }) => (
          <Modal key={id} />
        ))}
      </div>,
      portalRootElemRef.current,
    )
  );
}

export default function ModalProvider({ children }) {
  const [modalInfos, setModalInfos] = useState([]);
  const pushModal = (modal) => {
    const id = nanoid();
    setModalInfos((prev) => [...prev, { Modal: modal, id }]);
  };
  const popModal = () => {
    setModalInfos((prev) => prev.slice(0, -1));
  };

  return (
    <ModalContext.Provider value={{ pushModal, popModal }}>
      {children}
      <ModalContainer modalInfos={modalInfos} />
    </ModalContext.Provider>
  );
}
